import { INITIAL_STATE } from '@components';

export function dateToString(date: Date): string | undefined {
    if (!date || Number.isNaN(date.getTime())) return;

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const urlDate = `${day}-${month}-${year}`;

    return urlDate;
}

export function parseDate(dateParameter: string | null): Date | undefined {
    if (!dateParameter) return;

    const pattern = /^\d{2}-\d{2}-\d{4}$/;
    if (!pattern.test(dateParameter)) return;

    const [day, month, year] = dateParameter
        .split('-')
        .map(part => Number(part));
    const date = new Date(year, month - 1, day);

    return date;
}

export function isValidDate(date: Date): boolean {
    if (!date) return false;
    if (
        date < INITIAL_STATE.filter.fromDate ||
        date > INITIAL_STATE.filter.toDate
    )
        return false;
    return true;
}
